/**
 * StatusIcon component for displaying bastion and resource status.
 * Provides consistent status visualization across the application.
 */
import { BsCheckCircleFill, BsExclamationTriangleFill, BsHourglassSplit, BsXCircleFill, BsArchive, BsPauseFill } from 'react-icons/bs';

interface StatusIconProps {
    status: string;
    size?: number;
}

/**
 * Renders a status icon with appropriate color based on the status string.
 * Handles: Ready, Running, Pending, Creating, Error, Failed, Deleted, Suspended, and unknown states.
 */
const StatusIcon = ({ status, size = 20 }: StatusIconProps) => {
    let Icon = BsExclamationTriangleFill;
    let color = "text-warning";

    if (status === 'Ready' || status === 'Running') {
        Icon = BsCheckCircleFill;
        color = "text-success";
    } else if (status === 'Pending' || status === 'Creating') {
        Icon = BsHourglassSplit;
        color = "text-warning";
    } else if (status === 'Error' || status === 'Failed') {
        Icon = BsXCircleFill;
        color = "text-danger";
    } else if (status === 'Deleted') {
        Icon = BsArchive;
        color = "text-secondary";
    } else if (status === 'Suspended') {
        Icon = BsPauseFill;
        color = "text-secondary";
    }

    const displayStatus = status || 'Unknown';

    return (
        <div className="d-flex align-items-center gap-2">
            <Icon className={color} size={size} />
            <span>{displayStatus}</span>
        </div>
    );
};

export default StatusIcon;
